import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'

import {
  ValidateZipCodeClientRequest,
  ValidateZipCodeResponse,
} from '../../@types/ValidateZipCode'
import { api } from '../../Services/API'
import { useZipCodeStore } from '../../Stores/useZipCodeStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const formatZipCode = (value: string): ValidateZipCodeClientRequest => {
  const [zipCode, zipCodeExtension] = (value || '')?.split('-')

  return {
    zipCode,
    zipCodeExtension,
  }
}

const request = async (zipCode: string) => {
  const { data } = await api.post<ValidateZipCodeResponse>(
    API_ROUTES.validateZipCode,
    {
      ...formatZipCode(zipCode),
    },
  )

  return data
}

export const useValidateZipCode = () => {
  const { setZipCodeResult } = useZipCodeStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (zipCode: string) => request(zipCode),
    onSuccess(data) {
      setZipCodeResult(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
